import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUIStore } from '../../store/ui-store';
import { useUserStore } from '../../store/user-store';
import EditEventDetails from '../../components/events/edit-event-details';
import ViewEventDetails from '../../components/events/view-event-details';

function EventDetailsPage() {
  const { id } = useParams();
  const { currentUser, getUserDetails } = useUserStore();
  const { setTitle, setBreadcrumbs, clearBreadcrumbs } = useUIStore();

  useEffect(() => {
    setTitle(`Manage Events`);
    setBreadcrumbs([{ link: '/events', label: 'All events' }]);
  }, [currentUser, id, setBreadcrumbs, setTitle]);

  useEffect(
    () => () => {
      clearBreadcrumbs();
    },
    [clearBreadcrumbs],
  );

  return (
    <div className="px-12 pt-10 pb-[35px]">
      <ViewEventDetails />
    </div>
  );
}

export default EventDetailsPage;
